var _rect, _rect2, _line, _line2, _circle, _line3, _line4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorElectronics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.194,
    y: 15.371,
    width: 10.692,
    height: 19.127,
    rx: 0.722,
    ry: 0.722
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.268,
    y: 30.118,
    width: 7.598,
    height: 4.38
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.197,
    y1: 34.498,
    x2: 25.123,
    y2: 34.498
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.114,
    y1: 25.543,
    x2: 28.194,
    y2: 25.543
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.067,
    cy: 27.805,
    r: 0.317
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28.194,
    y1: 17.945,
    x2: 38.886,
    y2: 17.945
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28.194,
    y1: 31.875,
    x2: 38.886,
    y2: 31.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.194,30.118H4.667c-.858,0-1.553-.695-1.553-1.553V9.054c0-.858.695-1.553,1.553-1.553h25.973c.858,0,1.553.695,1.553,1.553v6.317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorElectronics);
export default __webpack_public_path__ + "static/media/indoor-electronics.615a829025db82bde215e2cd51c9f2d2.svg";
export { ForwardRef as ReactComponent };